import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';
import type { PosterMonetizationTag } from '@/interfaces/components/poster/PosterGraphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'MonetizationTag',
  props: {
    monetizationTag: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'click', monetizationTag: PosterMonetizationTag): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	monetizationTag: PosterMonetizationTag;
};

const shoppingBagIconUrl = `/${ASSETS_DIR}/img/icons/shopping-bag.svg`;




const { tc } = useI18n();

return { __sfc: true,shoppingBagIconUrl, props, emit, tc }
}

})